<template>
    <div class="gallery" >
        <div class="gallery__side-bar">
            <div v-for="(image, index) in galleryImages" :key="index" class="gallery__thumbnail-container">
                <img :class="thumbnailClass(index)" @click="updateImage(index)" :src="image.thumbnail" :alt="altText">
            </div>
        </div>
        <div class="gallery__image-container">
            <img class="gallery__image" :src="images[chosenImageIndex].original" :alt="altText"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImageGallery',
    data() {
        return {
            chosenImageIndex: 0,
            imageLimit: 4,
        };
    },
    props: {
        images: {
            required: true,
            type: Array,
        },
        altText: {
            required: false,
            type: String,
            default: 'Product image',
        },
    },
    methods: {
        updateImage(index) {
            this.chosenImageIndex = index;
        },
        thumbnailClass(index) {
            const selectedImage = index === this.chosenImageIndex;
            const normalClass = 'gallery__thumbnail';
            return selectedImage ? `${normalClass} ${normalClass}__selected` : normalClass;
        },
    },
    computed: {
        galleryImages() {
            const images = this.images.filter((image, index) => { return index < this.imageLimit; });
            return images;
        },
    },
};
</script>
